import { InstantResultsAnalyticsProvider, } from '../../api/analytics/instant-result-analytics.js';
import { documentIdentifier, makeAnalyticsAction, partialDocumentInformation, validateResultPayload, } from '../analytics/analytics-utils.js';
import { SearchPageEvents } from '../analytics/search-action-cause.js';
export const logInstantResultOpen = (result) => makeAnalyticsAction({
    prefix: 'analytics/instantResult/open',
    __legacy__getBuilder: (client, state) => {
        validateResultPayload(result);
        return client.makeDocumentOpen(partialDocumentInformation(result, state), documentIdentifier(result));
    },
    __legacy__provider: (getState) => new InstantResultsAnalyticsProvider(getState),
    analyticsType: 'itemClick',
    analyticsPayloadBuilder: (state) => {
        const docInfo = partialDocumentInformation(result, state);
        const docId = documentIdentifier(result);
        return {
            responseId: result.searchUid ?? '',
            position: docInfo.documentPosition,
            itemMetadata: {
                uniqueFieldName: docId.contentIDKey,
                uniqueFieldValue: docId.contentIDValue,
                title: docInfo.documentTitle,
                author: docInfo.documentAuthor,
                url: docInfo.documentUrl,
            },
        };
    },
});
//TODO: KIT-2859
export const logInstantResultsSearch = () => makeAnalyticsAction('analytics/instantResult/searchboxAsYouType', (client) => client.makeSearchboxAsYouType(), (getState) => new InstantResultsAnalyticsProvider(getState));
export const searchboxAsYouType = () => ({
    actionCause: SearchPageEvents.searchboxAsYouType,
});
